import { render, staticRenderFns } from "./QPageAuditDataTable.vue?vue&type=template&id=15ad7f1c&scoped=true&"
import script from "./QPageAuditDataTable.vue?vue&type=script&lang=js&"
export * from "./QPageAuditDataTable.vue?vue&type=script&lang=js&"
import style0 from "./QPageAuditDataTable.vue?vue&type=style&index=0&id=15ad7f1c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15ad7f1c",
  null
  
)

export default component.exports